import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getUserDetails } from "../../../services/operations/profileAPI";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../../redux/slices/profileSlice";
import toast from "react-hot-toast";
import { apiConnector } from "../../../services/apiconnector";
import { profileEndpoints } from "../../../services/apis";
import TableData from "../../common/TableData";

function OneStudent() {
  const { GET_USER_DETAILS_API } = profileEndpoints;
  const { studentId } = useParams();
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth);
  const [students, SetStudent] = useState([]);
  const [issued, SetIssued] = useState([]);
  const [allIssued, SetAllIssued] = useState([]);
  const [page,setPage] = useState(1)
  const[issuedTotalPage,setTotalIssuedPage] = useState(0)
  const [allTotalIssuedPage,setAllTotalIssuedPage] =useState(0)

  const [issuedBookTab , setIssuedBookTab] = useState(true)
  const[loading,setLoading] = useState(false)
  // console.log(studentId)

  const fetchStudent = async () => {
    // const toastId = toast.loading("Loading...");
    setLoading(true)
    try {
      const response = await apiConnector(
        "GET",
        `${GET_USER_DETAILS_API}/${studentId}?page=${page}&limit=12`,
        null,
        {
        // "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }
      );
      console.log("GET_USER_DETAILS API RESPONSE............", response);

      if (!response.data.success) {
        throw new Error(response.data.message);
      }
      // toast.success("fetched User Details");

      SetStudent(response?.data?.data?.userDetails)
      SetIssued(response?.data?.data?.paginatedIssuedBook)
      SetAllIssued(response?.data?.data?.paginatedAllIssuedBook)
      setTotalIssuedPage(response?.data?.data?.totalIssuedPages)
      setAllTotalIssuedPage(response?.data?.data?.totalAllIssuedPages)

      console.log(response?.data?.data?.paginatedAllIssuedBook[0])

    } catch (error) {
      console.log("GET_USER_DETAILS API ERROR............", error);
      // toast.error("Could Not Get User Details");
    }
    // toast.dismiss(toastId);
    setLoading(false)

  };

  useEffect(() => {
    
    fetchStudent();
  }, [page]);
  
  return (
    <>
    {loading ? (<div className="grid  place-items-center">
          <div className="spinner"></div>
        </div>) :
      
     ( <div className="bg-richblack-300 lg:p-10 rounded-3xl flex lg:gap-10 gap-2 ">
        <div>
          <img 
          className="rounded-2xl lg:w-[320px] w-[130px]"
          src={students.image} 
          
          alt="" />
        </div>
        <div className="lg:text-3xl font-mulish flex flex-col gap-4 font-semibold ">
          <p>Name:- {students.firstName + " " + students.lastName}</p>
          <p>Class:- {students.className}</p>
          <p>Session:- {students.session}</p>
          <p>Library No.:- {students.libraryId}</p>
          <p>Mobile No.:- {students.contactNumber}</p>
          <p>Gender:- {students.gender}</p>
        </div>
    </div>)
    }

    <div className="pt-10">
      <div className="flex justify-around bg-richblack-400 p-3 rounded-2xl">
        <button 
        onClick={(e)=>setIssuedBookTab(true)}
         className={`x p-3 rounded-3xl font-mulish font-bold  text-xl ${issuedBookTab ? "bg-pink-50" : "bg-transparent"}`}>Issued Book</button>
        <button 
        onClick={(e)=>setIssuedBookTab(false)}
         className={`x p-3 rounded-3xl font-mulish font-bold  text-xl ${!issuedBookTab ? "bg-pink-50" : "bg-transparent"}`}>All Issued Book</button>

      </div>

      {
        issuedBookTab ? ( 

          loading ? (<div className="grid  place-items-center">
          <div className="spinner"></div>
        </div>)
          :
          ( 
                  
              issued.length > 0 ?
              ( <TableData 
                  prop={issued}   
                  setPage={setPage}
                  currentPage={page}
                  totalPages={issuedTotalPage}
                   t={issuedBookTab}
                  /> )
                  
            : (<p className="text-center pt-5 text-3xl font-mulish"> No Issued Book  </p>)
         
           )

           ) : loading ? (<div> Loaing..... </div>)
          :
          ( 
            allIssued.length > 0 ?
              ( <TableData 
                  prop={allIssued}   
                  setPage={setPage}
                  currentPage={page}
                  totalPages={allTotalIssuedPage}
                   t={issuedBookTab}
                  /> )
                  
            : (<p className="text-center pt-5 text-3xl font-mulish"> No  book issued </p>)
             
                    
         
          
           )
      }

     
    </div>
    </>
  )
}

export default OneStudent;
